import { useState } from "react";
import Header from "./components/Header/Header";
import MainLayout from "./layouts/MainLayout";
import About from "./components/About";
import Skills from "./components/Skills";
import Certifications from "./components/Certifications";
// import Contact from "./components/Contact";
import Footer from "./components/Footer/Footer";

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <MainLayout isMenuOpen={isMenuOpen}>
        <About />
        <Skills />
        <Certifications />
        {/* <Contact /> */}
      </MainLayout>
      <Footer />
    </div>
  );
}

export default App;
